export default __webpack_public_path__ + "media/convenience_product_1.657c305e.png";